// Style for error pages
const Style = () => ({
  errorPageText: {
    marginTop: 15,
    marginBottom: 15,
  },
});

export default Style;
